import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchKpiMeInOrganizationArgs,
  FetchKpiTrainerArgs,
  FetchKpiOrgArgs,
} from '../api/types/stats.types';
import type { FetchKpiMeArgs } from '../api/statsKpi.api';

import {
  fetchKpiMeInOrganization,
  fetchKpiMeByOrganization,
  fetchKpiTrainer,
  fetchKpiOrg,
  fetchKpiMe,
} from '../api/statsKpi.api';

export const statsKpiQueryKeys = createQueryKeys('statsKpi', {
  fetchMe: (args: FetchKpiMeArgs = {}) => ({
    queryFn: () => fetchKpiMe(args),
    queryKey: [args],
  }),
  fetchMeByOrganization: () => ({
    queryFn: () => fetchKpiMeByOrganization(),
    queryKey: ['self'],
  }),
  fetchMeInOrganization: (args: FetchKpiMeInOrganizationArgs) => ({
    queryFn: () => fetchKpiMeInOrganization(args),
    queryKey: [args],
  }),
  fetchOrg: (args: FetchKpiOrgArgs) => ({
    queryFn: () => fetchKpiOrg(args),
    queryKey: [args],
  }),
  fetchTrainer: (args: FetchKpiTrainerArgs = {}) => ({
    queryFn: () => fetchKpiTrainer(args),
    queryKey: [args],
  }),
});
